module.exports = __webpack_public_path__ + "static/media/anyone-affiliate-marketing.84af1544.jpg";